module.exports = __webpack_public_path__ + "static/unitex logo-2db76ed7428251b83950faf5ce03bf8c.png";